"use client";

import { useEffect, useState } from "react";
import { Icon as OfflineIcon } from "@iconify/react/offline";
import { loadCoreSet, fetchIcon, isOffline } from "./registry";
import { BARE_ICON_MAP, BARE_ICON_FALLBACK } from "./bareMap";

interface Props {
  name: string;           // "solar:rocket-bold-duotone", "solar:rocket-bold-duotone" or "mdi:home"
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
  mask?: boolean;         // render as CSS mask (paintable via background) instead of <svg>
}

// Init core set on first import
loadCoreSet();

export default function RegistryIcon({ name, size = 24, color, style, className, mask }: Props) {
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);

  // Normalize: a prefixed name ("solar:rocket-bold-duotone", "solar:...") passes through as-is.
  // A bare name ("rocket") is NOT lucide — it runs through BARE_ICON_MAP to a Solar
  // duotone equivalent (house default), falling back to a generic Solar glyph when
  // uncovered. A missing/empty name must never crash the tree — a bad icon prop
  // renders nothing, not a white screen.
  const fullName = !name ? "" : name.includes(":") ? name : (BARE_ICON_MAP[name] ?? BARE_ICON_FALLBACK);
  // Офлайн ли глиф — спрашиваем сам поднабор, а не префикс имени. Solar-имя,
  // собранное в рантайме из данных (аватары, реестры команд), в скан кода не
  // попадает и обязано доехать сетью, как чужие префиксы.
  const isCore = isOffline(fullName);

  useEffect(() => {
    if (!fullName || isCore) { setReady(true); return; }
    fetchIcon(fullName).then(ok => {
      setReady(true);
      if (!ok) setFailed(true);
    });
  }, [fullName, isCore]);

  if (failed || !fullName) return null;

  return (
    <OfflineIcon
      icon={fullName}
      width={size}
      height={size}
      mode={mask ? "mask" : undefined}
      style={{ color, ...style }}
      className={className}
      data-icon={fullName}
    />
  );
}
